import React from 'react';

const SidebarElement = ({
  icon: Icon,
  filename = '',
  isActive = false,
  onClick,
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`w-full flex items-center gap-2 px-2 py-1.5 text-left text-sm rounded-sm border-l-2 transition-colors duration-200 ${
      isActive
        ? 'border-accent text-ink bg-page'
        : 'border-transparent text-muted hover:bg-page hover:text-ink'
    }`}
  >
    {Icon ? <Icon className="h-4 w-4 shrink-0" aria-hidden="true" /> : null}
    <span className="font-mono truncate">{filename}</span>
  </button>
);

export default SidebarElement;
